@if (type === 'agreement') {
  <app-button-setup-four></app-button-setup-four>
}
@if (type !== 'agreement' && !readingMode) {
  <app-button-setup-two [type]="type"></app-button-setup-two>
}
@if (readingMode) {
  <app-button-setup-one></app-button-setup-one>
}
